import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { Referral } from '../core/model/referral';
import { ReferralNote } from '../core/model/appointmentNote';
import { BaseService } from '../core/services/shared/base.service';

@Injectable({
  providedIn: 'root'
})
export class ReferralsService {

  constructor(private httpClient: HttpClient, private baseService: BaseService) { }

  getPracticeIncoming(): Observable<Referral[]> {
    return this.httpClient.get<Referral[]>('/api/get?url=referrals/PracticeIncoming');
  }

  getPracticeOutgoing(): Observable<Referral[]> {
    return this.httpClient.get<Referral[]>('/api/get?url=referrals/PracticeOutgoing ');
  }

  getPracticePatient(): Observable<Referral[]> {
    return this.httpClient.get<Referral[]>('/api/get?url=referrals/PracticePatient  ');
  }

  getReferrals(): Observable<Referral[]> {
    return this.baseService.get<Referral[]>(`Referral/GetReferrals`);
  }

  getReferral(id: number): Observable<Referral> {
    return this.httpClient.get<Referral>('/api/get?url=referrals/GetReferral/' + id);
  }

  getSpecialistReferrals(id: number): Observable<Referral> {
    return this.httpClient.get<Referral>('/api/get?url=referrals/Specialist/' + id);
  }

  getPatientProviderReferral(patientId: number, doctorId: number): Observable<Referral> {
    return this.httpClient.get<Referral>('/api/get?url=referrals/GetPatientProvider/' + patientId + '/' + doctorId);
  }

  getUpcomingReferrals(id: number): Observable<Referral[]> {
    return this.httpClient.get<Referral[]>('/api/get?url=referrals/GetUpcomingReferrals/' + id);
  }

  getActiveReferrals(id: number): Observable<Referral[]> {
    return this.httpClient.get<Referral[]>('/api/get?url=referrals/PracticeReferrals/' + id);
  }

  getPastReferrals(id: number): Observable<Referral[]> {
    return this.httpClient.get<Referral[]>('/api/get?url=referrals/GetPastReferrals/' + id);
  }

  getPractitionerNewReferralDashboard(id: number): Observable<Referral[]> {
    return this.httpClient.get<Referral[]>('/api/get?url=referrals/GetPractitionerNewReferralDashboard/' + id);
  }

  getPractitionerReferralByPractitionerId(id: number): Observable<Referral[]> {
    return this.baseService.get<Referral[]>(`Practitioner/GetPractitionerReferralByPractitionerId?practitionerId=${id}`);
  }

  getPractitionerFromReferralList(request: any): Observable<Referral[]> {
    return this.baseService.post<Referral[]>(`Referral/GetPractitionerFromReferralList`, request);
  }

  getPatientReferralList(request: any): Observable<Referral[]> {
    return this.baseService.post<Referral[]>(`Referral/GetPatientReferralList`, request);
  }

  getPractitionerToReferralList(request: any): Observable<Referral[]> {
    return this.baseService.post<Referral[]>(`Referral/GetPractitionerToReferralList`, request);
  }

  getPractitionerToReferralListNoAppointments(request: any): Observable<Referral[]> {
    return this.baseService.post<Referral[]>(`Referral/GetPractitionerToReferralListNoAppointments`, request);
  }

  createReferral(referral: Referral): Observable<Referral> {
    return this.httpClient.post<Referral>('/api/post?url=referrals/CreateReferral', referral);
  }

  CreateOrUpdateReferral(referral: Referral): Observable<Referral> {
    return this.httpClient.post<Referral>('/api/post?url=referrals/CreateOrUpdateReferral', referral);
  }

  deactivateReferral(referralId: number | string): Observable<any> {
    return this.httpClient.delete('/api/delete?url=referrals/DeactivateReferral/' + referralId);
  }

  getPatientAppointmentsNotes(id: number | string): Observable<ReferralNote[]> {
    return this.httpClient.get<ReferralNote[]>('/api/get?url=referrals/GetPatientAppointmentsNotes/' + id);
  }

  updateAvailability(referral: Referral): Observable<Referral> {
    return this.httpClient.put<Referral>('/api/put?url=referrals/' + referral.id, referral);
  }

  createAppointmentNote(appointmentNote: ReferralNote): Observable<ReferralNote> {
    return this.httpClient.post<ReferralNote>('/api/post?url=referrals/CreateAppointmentNote', appointmentNote);
  }
}
